export default {
    unsubscribe: {
        title:
            'You have successfully unsubscribed from our automated app email reminders and notifications.',
        body:
            'To set meditation reminders or emails in the future, please login to the Chill Anywhere app and go to Settings to re-activate your Reminders.'
    }
};
